import React from 'react'
import { Helmet } from 'react-helmet'
import logoTSE from '../../static/logoTSE.png'

export default function SEO({ children, location, description, title, image }) {
  const defaultDescription =
    'Tribunal Supremo de Elecciones, República de Costa Rica. Consulta de lugar de votación y candidaturas. Elecciones Municipales 2024.'
  return (
    <Helmet titleTemplate={`TSE - %s`}>
      <html lang="es"></html>
      <title>{title}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charSet="utf-8" />
      <meta name="description" content={defaultDescription}></meta>
      {/* Open Graph - compartir en redes sociales */}
      {location && <meta property="og:url" content={location.href} />}
      <meta
        name="twitter:image"
        content={`https://www.tse.go.cr/imgs/Logo%20TSE/logo-elec2024-mini.png`}
      />
      <meta property="og:image" content={logoTSE} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="600" />
      <meta property="og:image:height" content="297" />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content="¿Dónde votar? TSE Costa Rica" />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@TSECostaRica" />

      {children}
    </Helmet>
  )
}
